import React from 'react';
import { ShieldCheck, Copyright } from 'lucide-react';
import logo_icp from '../../assets/logo_icp.png';
import logo_iti from '../../assets/logo_iti.png';

// Footer em CSS puro (sem MUI) — o MUI só era usado aqui e pesava o bundle inteiro.
export default function Footer() {
    const year = new Date().getFullYear();

    return (
        <footer style={S.footer}>
            <div style={S.container}>
                <div style={S.row}>
                    {/* SEÇÃO LEGAL E SELOS */}
                    <div style={S.colLeft}>
                        <div style={S.selos}>
                            <img src={logo_iti} alt="Logo ITI" style={S.selo} />
                            <img src={logo_icp} alt="Logo ICP-Brasil" style={S.selo} />
                        </div>
                        <p style={S.legal}>
                            Documento digital de identificação estudantil com validade em todo o
                            território nacional, emitido conforme a norma do <strong>ITI</strong> e
                            padrão <strong>ICP-Brasil</strong>.
                        </p>
                    </div>

                    {/* LINKS E AMBIENTE SEGURO */}
                    <div style={S.colRight}>
                        <div style={S.links}>
                            <a href="/termos-de-uso" style={S.link}>Termos de Uso</a>
                            <a href="/politica-de-privacidade" style={S.link}>Políticas de Privacidade</a>
                            <span style={S.seguro}><ShieldCheck size={16} /> Ambiente Seguro</span>
                        </div>
                        <img src={`${process.env.PUBLIC_URL}/nomeUnae.png`} alt="UNAE Estudantil" style={S.logo} />
                    </div>
                </div>

                <div style={S.divider} />

                <div style={S.copy}>
                    <Copyright size={12} />
                    <span style={S.copyText}>{year} — Todos os direitos reservados.</span>
                </div>
            </div>
        </footer>
    );
}

const S = {
    footer: {
        marginTop: 'auto',
        padding: '36px 0',
        backgroundColor: 'rgba(255,255,255,0.7)',
        backdropFilter: 'blur(12px)',
        borderTop: '1px solid rgba(0,0,0,0.05)',
        width: '100%',
        fontFamily: "'Inter', sans-serif",
    },
    container: { maxWidth: 1152, margin: '0 auto', padding: '0 24px' },
    row: { display: 'flex', flexWrap: 'wrap', gap: 32, alignItems: 'center', justifyContent: 'space-between' },
    colLeft: { flex: '1 1 320px', display: 'flex', flexDirection: 'column', gap: 16 },
    colRight: { flex: '1 1 280px', display: 'flex', flexDirection: 'column', gap: 16, alignItems: 'flex-end' },
    selos: { display: 'flex', gap: 24, alignItems: 'center' },
    selo: { height: 50, filter: 'grayscale(100%)', opacity: 0.7 },
    legal: { color: '#64748b', maxWidth: 450, lineHeight: 1.6, fontSize: 12.5, margin: 0 },
    links: { display: 'flex', gap: 24, alignItems: 'center', flexWrap: 'wrap', justifyContent: 'flex-end' },
    link: { color: '#64748b', fontWeight: 600, fontSize: 12.5, textDecoration: 'none' },
    seguro: { display: 'inline-flex', alignItems: 'center', gap: 5, color: '#2e7d32', fontWeight: 700, fontSize: 12.5 },
    logo: { height: 42, width: 'auto' },
    divider: { height: 1, background: 'rgba(0,0,0,0.08)', margin: '28px 0' },
    copy: { display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 5, color: '#9aa1ab' },
    copyText: { fontSize: '0.65rem', textTransform: 'uppercase', letterSpacing: 1.5, fontWeight: 700 },
};
